import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import BookingsEditForm from './BookingsEditForm';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchBooking } from 'store/actions/bookings/fetchBookings';
import { fetchOrderBookingActivities } from 'store/actions/orderActivitiesActions';
import { reduxForm } from 'redux-form';
import { updateBooking } from 'store/actions/bookings/updateBookings';

class BookingsEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchActivities,
            history,
            id,
            dispatchForm,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    reject();
                },
                onSuccess: () => {
                    // When the user is not an admin we will resolve the function.
                    if (authHelper.isAdmin()) {
                        // Update the booking activies.
                        dispatchActivities({
                            id: id,
                        });
                    }

                    resolve(history.push(`/bookings/${ id }/show`));
                },
                id: id,
                values: values,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const fullName = utils.fullName(data.first_name, data.last_name);
        const orderId = data.order_id;

        const breadcrumbs = [
            {
                label: translate('resources.bookings.title'),
                link: '/bookings',
            },
            {
                label: `${ fullName } (${ orderId })`,
                link: `/bookings/${ orderId }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.bookings.actions.edit', {
                        name: utils.fullName(data.first_name, data.last_name),
                        id: data.order_id,
                    }) } />

                    <Actions>
                        <ListButton url='/bookings' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <BookingsEditForm
                            data={ data }
                            form='bookings_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

BookingsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchActivities: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    translate: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateBooking(values));
        },
        dispatchActivities: (values) => {
            dispatch(fetchOrderBookingActivities(values));
        },
    };
};

const enhance = compose(
    translate,
    reduxForm({
        enableReinitialize: true,
        form: 'order-edit',
        keepDirtyOnReinitialize: true,
    }),
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        action: fetchBooking,
        resource: 'bookings',
    })
);

export default enhance(BookingsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/bookings/edit/BookingsEditContainer.js